// @ts-nocheck
import './assets/main.css'
import './assets/theme.css'
import './assets/ads.css'
import './style.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import i18n from './i18n'
import vueQuery from './plugins/vueQuery'

import App from './App.vue'
import router from './router'
import { reportWebVitals } from './utils/vitals'
import vLazyRender from './directives/vLazyRender'
import logger from './utils/logger'
import { useToastStore } from './stores/toastStore'

// Lazy load telemetry only when enabled (large impact on bundle size)
if (import.meta.env.VITE_TELEMETRY_ENABLED === 'true') {
  import('./utils/telemetry').then(module => {
    module.initTelemetry()
  })
}

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(vueQuery)
app.use(i18n)
app.use(router)
app.directive('lazy-render', vLazyRender)

// Global Error Handling
app.config.errorHandler = (err, instance, info) => {
    logger.error(`Vue Error [${info}]:`, err)

    // Show toast notification
    try {
        const toastStore = useToastStore()
        toastStore.error(i18n.global.t('errors.INTERNAL_ERROR'))
    } catch (e) {
        console.error('Failed to show error toast', e)
    }
}

window.addEventListener('error', (event) => {
    // Ignore resize-observer errors which are often harmless
    if (event.message === 'ResizeObserver loop limit exceeded') return

    logger.error('Global Error:', event.error || event.message)
    try {
        const toastStore = useToastStore()
        toastStore.error(i18n.global.t('errors.INTERNAL_ERROR'))
    } catch (e) {
        console.error('Failed to show error toast', e)
    }
})

window.addEventListener('unhandledrejection', (event) => {
    logger.error('Unhandled Promise Rejection:', event.reason)
    try {
        const toastStore = useToastStore()
        toastStore.error(i18n.global.t('errors.INTERNAL_ERROR'))
    } catch (e) {
        console.error('Failed to show error toast', e)
    }
})

app.mount('#app')
reportWebVitals()
